export default __webpack_public_path__ + "static/media/energy.bc783938.jpg";